<template>
  <div class="">
    <div class="jtjjContent">
      <div class="jtjjTitle">{{ indexObj.name }}</div>
      <div class="jtjjNr" v-html="indexObj.content"></div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router';
const router = useRouter();
const route = useRoute();
let indexObj = reactive({});
import { useStore } from 'vuex';
const pageObj = reactive({
  typeName: '集团简介',
});

const store = useStore();
async function getList() {
  const res = await store.dispatch('getQyInfo/getQyInfo', pageObj);
  Object.assign(indexObj, res.data);
  console.log(indexObj);
}

onMounted(() => {
  getList();
});
</script>
<style lang="less" scoped>
.jtjjContent {
  display: flex;
  flex-direction: column;
  align-items: center;

  .jtjjTitle {
    font-size: 22px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 40px 0 30px;
  }
  .jtjjNr {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 0 0 16px;
    line-height: 30px;
    text-indent: 24px;
  }
}
</style>
